// Environment configuration service

export class Config {
    private static readonly LOCAL_BOT_KEY = '__local_bot';

    static isLocalMode(): boolean {
        return !!localStorage.getItem(this.LOCAL_BOT_KEY);
    }

    static getBotApiEndpoint(): string {
        return this.isLocalMode() ? 'http://127.0.0.1:8000' : 'https://bot.ml4.i2x.ai';
    }

    static getSimulatorEndpoint(version = 'v1', useWebSocket = true): string {
        const protocol = useWebSocket ? (this.isLocalMode() ? 'ws' : 'wss') : (this.isLocalMode() ? 'http' : 'https');
        const host = this.isLocalMode() ? '127.0.0.1:8082' : 'bot.ml4.i2x.ai';

        return `${protocol}://${host}/simulator/${version}`;
    }

    static getBotApiPrefix(version = 'v1'): string {
        return `/api/chat/${version}`;
    }

    static setLocalMode(enabled: boolean): void {
        if (enabled) {
            localStorage.setItem(this.LOCAL_BOT_KEY, 'true');
        } else {
            localStorage.removeItem(this.LOCAL_BOT_KEY);
        }
    }
}
